/* eslint-disable @typescript-eslint/ban-ts-comment */
import { addModal, closeCurrentModal } from 'weblite-web-modal-viewer'
import { IOSCallProblems } from './ios-call-problems'

const COMPONENT_ID = 'iOSCallProblems'

const showIOSCallProblems = (props: Parameters<typeof IOSCallProblems>[0]) =>
  addModal({ id: COMPONENT_ID, props })
// TODO: can be removed
export const showIOSCallProblemsDialog = () =>
  new Promise((resolve, reject) =>
    showIOSCallProblems({
      onConfirm: async () => {
        await closeCurrentModal()
        resolve(null)
      },
      onCancel: async () => {
        await closeCurrentModal()
        reject()
      },
    }),
  )

export default {
  [COMPONENT_ID]: {
    Component: IOSCallProblems,
  },
}
